/* eslint-disable react/no-array-index-key */
import { FormApi } from 'final-form';
import React, { Fragment } from 'react';

import { InputErrorField } from '../pages/SchedulingPage/components/styles';

interface IProps {
  form: Pick<FormApi, 'getState'>;
  field: string;
  submitField?: string;
}

export default function InputError({ form, field, submitField = field }: IProps) {
  const { errors, dirtyFieldsSinceLastSubmit, submitErrors, touched } = form.getState();
  const currentErrors =
    (touched?.[field] && errors?.[field]) ||
    (!dirtyFieldsSinceLastSubmit?.[field] && submitErrors?.[submitField]);
  if (!currentErrors) {
    return null;
  }
  return (
    <Fragment>
      {currentErrors.map((error: string, index: number) => (
        <InputErrorField key={index}>{error}</InputErrorField>
      ))}
    </Fragment>
  );
}
